<template>
  <v-dialog
    v-model="localValue"
    max-width="400"
  >
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>

      <v-card-text :inner-html.prop="receivedText">
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn
          color="blue-grey lighten-3"
          text
          @click="normal ? normalDeny() : deny()"
        >
          Prekliči
        </v-btn>

        <v-btn
          color="red darken-2"
          dark
          @click="normal ? normalConfirm() : confirm()"
        >
          {{okBtnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String
    },
    text: {
      required: true,
      type: String
    },
    okBtnText: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: Boolean
    },
    normal: {
      default: true,
      required: false,
      type: Boolean
    }
  },
  data () {
    return {
      receivedText: this.text,
      localValue: this.value,
      resolve: null,
      reject: null
    }
  },
  methods: {
    pop (text = null) {
      if (text) {
       this.receivedText = text
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    confirm () {
      this.resolve(true)
    },
    deny () {
      this.localValue = null
      this.resolve(false)
    },
    normalDeny () {
      this.$emit('input', false)
    },
    normalConfirm () {
      this.$emit('input', false)
      this.$emit('confirmed')
    }
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
